import { useQuery } from "react-query";
import { ParcelService } from "$services";
import { PackageType } from "$types";

export const usePackageTypesQuery = () => {
  return useQuery<PackageType[]>(
    ["getPackageTypes"],
    () => ParcelService.getPackageTypes(),
    {
      staleTime: 60 * 60 * 1000, // Package types change rarely
    }
  );
};
